module.exports = __webpack_public_path__ + "img/eikaworkshop.4a28809d.jpeg";